// extracted by mini-css-extract-plugin
module.exports = {"header":"IframeHeader_header__3mCXU","logo":"IframeHeader_logo__1rJ9m","navbar":"IframeHeader_navbar__SQDF2","links":"IframeHeader_links__peElq"};